import { gql } from '@apollo/client'

export const personaDeleteOne = gql`
  mutation PersonaDeleteOne($_id: String!) {
    personaDeleteOne(_id: $_id)
  }
`
